<template>
    <figure v-lazyload class="image__wrapper">
    <img
        src="static/white-pixel.png"
        class="image__item"
        :data-url="source"
        alt="Cargando imagen..."
        :style="size"
    >
    </figure>
</template>
<script>
/* eslint-disable */
export default{
    name: "ImageItem",
    props: {
        source: {
            type: String,
            required: true
        },
        size: {
            type: String,
            required: false
        }
    }
}
</script>
<style>
.image__wrapper{
    margin:0px!important;
}
figure {
    background-image:url(/static/loader-img.gif);
    background-repeat:no-repeat;
    background-position: center;
}
</style>


// WEBPACK FOOTER //
// src/components/ImageItem.vue